export default __webpack_public_path__ + "static/media/resetIcon.2fe22742.svg";